<div style=" border: 2px solid; border-radius: 19px; padding: 0.5rem; background-color: #fff;">
    <img [src]="qrImgSrc" class="p-2" style="width: -webkit-fill-available;"  loading="lazy" />
</div>